import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class EventClassgroupGraphRoute extends Route {
  @service eventData;

  model(params) {
    const classGroupUuid = params.classgroup_uuid;
    const eventUuid = this.paramsFor('event').event_uuid;

    console.log(`[EventClassgroupGraphRoute] Loading graph for classgroup ${classGroupUuid} in event ${eventUuid}`);

    return {
      eventUuid,
      classGroupUuid
    };
  }
}
